import type { Dispatch, SetStateAction } from "react";
import { t } from "@/i18n-js/instance";
import type { CoursesDirectorySpace } from "@/react/types/CoursesDirectory";
import type { SearchSpace } from "@circle-react/types/Search/Space";
import { useModalData } from "@circle-react-uikit/ModalV2";
import { SortableList } from "@circle-react-uikit/SortableList";
import { Typography } from "@circle-react-uikit/Typography";
import { CourseItem } from "./CourseItem";

interface CoursesListProps {
  courses: SearchSpace[] | CoursesDirectorySpace[];
  onSort:
    | Dispatch<SetStateAction<SearchSpace[] | undefined>>
    | ((data: CoursesDirectorySpace[]) => void);
}

export const CoursesList = ({ courses, onSort }: CoursesListProps) => {
  const { contentPortalElement } = useModalData();

  return (
    <div className="border-primary bg-primary mt-6 overflow-hidden rounded-lg border">
      <div className="bg-secondary border-primary border-b px-5 py-2">
        <Typography.LabelSm weight="semibold">
          {t("courses.directory.options_modal.reorder_courses.count", {
            count: courses.length,
          })}
        </Typography.LabelSm>
      </div>
      <SortableList
        items={courses}
        onSort={onSort}
        lockedVerticalAxis
        distance={10}
      >
        <SortableList.List
          className="divide-primary max-h-96 divide-y overflow-y-scroll"
          gap={0}
        >
          {courses.map(course => (
            <SortableList.Item key={course.id} item={course} className="h-14">
              <CourseItem />
            </SortableList.Item>
          ))}
        </SortableList.List>
        <SortableList.DragOverlay
          portalTo={contentPortalElement}
          shouldRestrictToParent
        >
          <CourseItem isDragOverlay />
        </SortableList.DragOverlay>
      </SortableList>
    </div>
  );
};
